var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.63755 6.62029L0.327548 1.04729C0.238904 0.954302 0.189453 0.83076 0.189453 0.70229C0.189453 0.57382 0.238904 0.450279 0.327548 0.357291L0.333549 0.35129C0.376522 0.306055 0.428248 0.270036 0.485581 0.245422C0.542914 0.220808 0.604655 0.208115 0.667048 0.208115C0.729442 0.208115 0.791183 0.220808 0.848516 0.245422C0.905849 0.270036 0.957575 0.306055 1.00055 0.35129L6.00055 5.59929L10.9985 0.35129C11.0415 0.306055 11.0932 0.270036 11.1506 0.245422C11.2079 0.220808 11.2697 0.208115 11.332 0.208115C11.3944 0.208115 11.4562 0.220808 11.5135 0.245422C11.5708 0.270036 11.6226 0.306055 11.6655 0.35129L11.6715 0.357291C11.7602 0.450279 11.8096 0.57382 11.8096 0.70229C11.8096 0.83076 11.7602 0.954302 11.6715 1.04729L6.36155 6.62029C6.31485 6.6693 6.25869 6.70832 6.19646 6.73498C6.13424 6.76164 6.06724 6.77539 5.99955 6.77539C5.93185 6.77539 5.86486 6.76164 5.80263 6.73498C5.74041 6.70832 5.68425 6.6693 5.63755 6.62029Z",
    fill: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.ca5038e80a0c0a62bf61a4a8f0241745.svg";
export { ForwardRef as ReactComponent };